<!-- 视频 -->
<template>
	<div class="wrap">

		<div class="top">
			<span @click="$router.push('/')">首页</span>
			<img src="../../assets/icon-7.png" class="top-icon">
			<span @click="$router.push('/index/video-column')">视频</span>
			<ul class="tab-list">
				<li v-for="(item,index) in tabList" :class="{active: tabId == index}" @click="active(index)" :key="index">
					<a href="javascript:void(0)">{{item.title}}</a>
				</li>
				<li :class="{active: tabId == -1}" @click="active(-1)">
					<a href="javascript:void(0)">产品</a>
				</li>
			</ul>
		</div>

		<div class="container">
			<!-- 咨询 -->
			<ul class="information-list" v-if="tabId >= 0">
				<li @click="consultationResultsDetails(item.id)" v-for="(item, index) in list" :key="index">
					<div class="information-img-box">
						<img :src="item.cover" class="information-img">
						<img src="../../assets/play.png" class="play-icon">
					</div>
					<div class="information-sidebar">
						<p class="information-name">{{item.title}}</p>
						<p class="information-msg">{{item.desc}}</p>
						<div class="information-btn-box">
							<button type="button" class="information-btn">查看详情</button>
						</div>
					</div>
				</li>
				<!-- 无数据显示 -->
				<div class="normal-box" v-if="list.length == 0">
					<img src="../../assets/normal-1.png">
					暂无数据
				</div>
			</ul>
			<!-- 养生 -->
			<!-- <ul class="information-list" v-show="tabId == 1">
				<li @click="consultationResultsDetails">
					<div class="information-img-box">
						<img src="../../assets/img-blue.png" class="information-img">
						<img src="../../assets/play.png" class="play-icon">
					</div>
					<div class="information-sidebar">
						<p class="information-name">有勇气去改变可以改变的事，有胸怀去接受可以改变的事</p>
						<p class="information-msg">酒店房间干净、舒适。酒店楼下还有商区，直通国贸三期。酒店大堂富丽堂皇，红柱子金壁画很有中国特色。酒店楼下还有商区，直通国贸四期。</p>
						<div class="information-btn-box">
							<button type="button" class="information-btn">查看详情</button>
						</div>
					</div>
				</li>
				<div class="normal-box">
					<img src="../../assets/normal-1.png">
					暂无数据
				</div>
			</ul> -->
			<!-- 产品 -->
			<ul class="list" v-if="tabId == -1">
				<li @click="productDetails(item.goods_set.id)" v-for="(item, index) in list" :key="index">
					<div class="product-item-column2">
						<div class="img-box">
							<img :src="item.goods_set.cover" class="product-item-column2-img">
						</div>
						<div class="product-item-column2-bottom">
							<div class="product-item-column-name2">{{item.goods_set.name}}</div>
							<div class="product-item-column2-row-between">
								<div class="product-item-column2-price">
									￥{{item.goods_set.low_price}}
									<span>￥{{item.line_price}}</span>
								</div>
								<!-- <button type="button" class="product-item-column2-btn">
									<img src="../../assets/add-icon.png">
								</button> -->
							</div>
						</div>
					</div>
				</li>
				<!-- 无数据显示 -->
				<div class="normal-box" v-if="list.length == 0">
					<img src="../../assets/normal-1.png">
					暂无数据
				</div>
			</ul>

			<!-- <div class="box-end">
				<el-pagination background layout="prev, pager, next" :total="1000">
				</el-pagination>
			</div> -->

		</div>

	</div>
</template>

<script>
	import { videoGetCateTree, videoGetVideoGoods, videoGetVideoList } from '../../service/service';
import { listenerScrollToBottom } from '../../utils/util';
	export default {
		components: {
		},
		data() {
			return {
				//选项卡
				tabId: 0,
				tabList: [],

				list: [],
				page: 1,
				page_num: 20,
			};
		},
		mounted() {
			this.getCateTree();
			// 监听滚动到底部
			listenerScrollToBottom(() => this.getList());
		},
		methods: {
			getCateTree() {
				videoGetCateTree().then(({ code, msg, data }) => {
					if (code == 1) {
						this.tabList = data.list;
						if (this.tabList.length == 0) {
							this.tabId = -1;
						}
						this.page = 1;
						this.getList();
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 获取列表
			getList() {
				const {
					page,
					page_num,
					tabId,
					tabList
				} = this;
				const req = tabId == -1 ? videoGetVideoGoods : videoGetVideoList;
				const params = {
					page,
					page_num,
					...(tabId == -1 ? {} : {
						first_classify: tabList[tabId].id
					}),
				};
				req(params).then(({code, msg, data}) => {
					if (code === 1) {
						const list = data.list;
						this.list = page > 1 ? [...this.list, ...list] : list;
						if (list.length === 0) {
							this.$message.info('没有更多数据了');
						} else {
							this.page = this.page + 1;
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			//选项卡
			active(index) {
				this.tabId = index;
				this.page = 1;
				this.getList();
			},
			//跳转商品详情
			productDetails(id) {
				this.$router.push('/index/product-details?id=' + id);
			},
			// 咨询详情
			consultationResultsDetails(id) {
				this.$router.push('/index/video-details?id=' + id);
			},
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 40px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		margin-bottom: 43px;
	}


	.tab-list {
		flex: 1;
		height: 70px;
		display: flex;
		margin-left: 22px;
	}

	.tab-list>li {
		width: 200px;
		height: 70px;
	}

	.tab-list>li>a {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #111111;
		font-size: 18px;
	}

	.tab-list>li.active>a {
		background-color: #F2501A;
		color: #FFFFFF;
		border-radius: 5px;
	}

	.font {
		color: #202020;
		font-size: 16px;
		padding: 0 30px;
	}

	.information-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.information-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-bottom: 11px;
		padding: 10px;
		box-sizing: border-box;
	}

	.information-img-box {
		width: 315px;
		height: 192px;
		position: relative;
	}

	.information-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 5px;
	}

	.play-icon {
		width: 47px;
		height: 47px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
	}

	.information-sidebar {
		flex: 1;
		height: 192px;
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.information-name {
		width: 100%;
		color: #111111;
		font-size: 24px;
		font-weight: 500;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.information-msg {
		width: 80%;
		color: #484848;
		font-size: 18px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}



	.information-btn-box {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.information-btn {
		color: #FFFFFF;
		font-size: 18px;
		width: 131px;
		height: 51px;
		line-height: 51px;
		background-color: #F2501A;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 9px;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 40%;
		margin-bottom: 6px;
	}

	.list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.list>li {
		width: 19.2%;
		margin-right: 1%;
		margin-bottom: 1%;
		border-radius: 8px;
		background-color: #fff;
		overflow: hidden;
	}

	.list>li:nth-child(5n) {
		margin-right: 0;
	}

	.product-item-column2 {
		width: 100%;
		height: 100%;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
	}

	.img-box {
		width: 100%;
		height: 228px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	}

	.product-item-column2-img {
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0 0;
		object-fit: cover;
	}

	.product-item-column2-bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 8px 10px;
		box-sizing: border-box;
	}

	.product-item-column-name2 {
		width: 100%;
		height: 36px;
		line-height: 18px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #202020;
		font-weight: bold;
		font-size: 14px;
	}

	.product-item-column2-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 13px;
	}

	.product-item-column2-btn {
		width: 27px;
		height: 27px;
		line-height: 27px;
		border-radius: initial;
	}

	.product-item-column2-btn>img {
		width: 100%;
		height: 100%;
	}

	.product-item-column2-price {
		color: #F2501A;
		font-size: 16px;
	}

	.product-item-column2-price>span {
		color: #919191;
		font-size: 14px;
		margin-left: 16px;
		text-decoration: line-through;
	}

	.box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 37px 0;
	}


	.el-pagination.is-background>>>.btn-next,
	.el-pagination.is-background>>>.btn-prev,
	.el-pagination.is-background>>>.el-pager li {
		background-color: #fff !important;
	}

	.el-pagination.is-background>>>.el-pager li:not(.disabled).active {
		background-color: #F2501A !important;
		color: #FFF;
	}

	.el-pagination.is-background>>>.el-pager li:not(.disabled):hover {
		color: #F2501A !important;
	}
</style>
